import React from "react";
import "../../App.css";
import VendorHomeView from "./components/VendorHomeView";
import { AppBarPadding, BottomPadding } from "../../utils/helperUtils";
import CustomerHomeView from "./components/CustomerHomeView";
import EventsHomeView from "../Events/EventsHomeView";

const HomeView = () => {

  return (

    <>
      <EventsHomeView/>
      {/* <CustomerHomeView /> */}
      <VendorHomeView />
    </>
  );
};

export default HomeView;
